import { Moment } from 'moment';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { UserNotReadyReason } from '@nimbus-library/features/user-state/models/not-ready-reason';

export enum StateBannerType {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  InCall = 'InCall',
  Ringing = 'Ringing',
  Acw = 'Acw',
  Rona = 'Rona',
}

export interface IStateBanner {
  type: StateBannerType;
  text: TranslationKeys;
  notReadyReason?: UserNotReadyReason;
  cssClass: string;
  subtext?: TranslationKeys;
  countUpFrom?: Moment;
  countDownTo?: Moment;
  countDownLeftSeconds?: number;
  allowToStop?: boolean;
  allowToExtend?: boolean;
  stopHandler?: (callBackend?: boolean) => void;
  extendHandler?: () => void;
}
